import { React, useState, useEffect } from "react";
import {
  fetchCandidatePreferences,
  submitPreferences,
  fetchSelectedPreferences,
} from "src/services/Preferences/PreferenceServices";
import { loadingState } from "src/atom/LoadingState";
import { useSetRecoilState } from "recoil";
import { fetchMilestoneInstructions } from "src/services/MainPage/GenericService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";

const CandidatePreference = ({ data }) => {
  const enableLoader = useSetRecoilState(loadingState);
  const [allPreferences, setAllPreferences] = useState([]);
  const [preferences, setPreferences] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [priorityInput, setPriorityInput] = useState("");
  const [milestoneInst, setMilestoneInst] = useState({});

  const handleNext = async (e) => {
    e.preventDefault();
    enableLoader(true);
    data?.onChange(data?.activeIndex);
    enableLoader(false);
  };

  const fetchPreferencesApiCall = async () => {
    enableLoader(true);
    var fetchPreferences = async () => {
      var response = await fetchCandidatePreferences(data.pageId);
      if (response.success) {
        setPreferences(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        alert(response.message);
      }
    };
    fetchPreferences();
  };

  const fetchSelectedPreferencesApiCall = async () => {
    enableLoader(true);
    var fetchPreferences = async () => {
      var response = await fetchSelectedPreferences(data.milestoneId);
      if (response.success) {
        var all_prefrences = [];
        preferences.forEach((preference) => {
          var preference_obj = {
            priority: response.body?.[preference.id]
              ? response.body?.[preference.id]
              : 400,
            departmentName: preference.departmentName,
            id: preference.id,
            qualificationCategory: preference.qualificationCategory,
          };
          all_prefrences.push(preference_obj);
        });
        all_prefrences.sort((a, b) => a.priority - b.priority);
        setAllPreferences(all_prefrences);
        enableLoader(false);
      } else {
        enableLoader(false);
        alert(response.message);
      }
    };
    fetchPreferences();
  };

  useEffect(() => {
    fetchPreferencesApiCall();
    fetchMilestoneInstApiCall();
  }, []);

  useEffect(() => {
    if (preferences?.length) {
      fetchSelectedPreferencesApiCall();
    }
  }, [preferences]);

  const handleSubmit = async (e) => {
    const transformedPreferences = {};
    allPreferences.forEach((item, index) => {
      transformedPreferences[item.id] = index + 1;
    });
    enableLoader(true);
    const response = await submitPreferences(
      transformedPreferences,
      data.milestoneId
    );
    if (response.success) {
      data.onChange(data.activeIndex);
      enableLoader(false);
    } else {
      enableLoader(false);
    }
  };

  const handleSelectId = (id) => {
    setSelectedId(id);
  };

  const handleMoveToTop = () => {
    allPreferences.unshift(allPreferences.splice(selectedId, 1)[0]);
    setAllPreferences([...allPreferences]);
    setSelectedId(null);
  };

  const handleMoveToBottom = () => {
    const removedItem = allPreferences.splice(selectedId, 1)[0];
    allPreferences.push(removedItem);
    setAllPreferences([...allPreferences]);
    setSelectedId(null);
  };

  const handleMoveToIndex = () => {
    if (
      priorityInput <= 0 ||
      priorityInput > allPreferences.length ||
      priorityInput === selectedId
    ) {
      return;
    }
    const removedItem = allPreferences.splice(selectedId, 1)[0];
    const newIndex = priorityInput - 1;
    allPreferences.splice(newIndex, 0, removedItem);
    setAllPreferences([...allPreferences]);
    setPriorityInput("");
    setSelectedId(null);
  };

  const fetchMilestoneInstApiCall = async () => {
    var fetchInstructions = async () => {
      enableLoader(true);
      var response = await fetchMilestoneInstructions(data.milestoneId);
      if (response.success) {
        setMilestoneInst(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    fetchInstructions();
  };

  const handleRowShift = (index, direction) => {
    if (direction === "up" && index > 0) {
      const selectedPreferencesCopy = [...allPreferences];
      const temp = selectedPreferencesCopy[index];
      selectedPreferencesCopy[index] = selectedPreferencesCopy[index - 1];
      selectedPreferencesCopy[index - 1] = temp;
      setAllPreferences(selectedPreferencesCopy);
    } else if (direction === "down" && index < allPreferences.length - 1) {
      const selectedPreferencesCopy = [...allPreferences];
      const temp = selectedPreferencesCopy[index];
      selectedPreferencesCopy[index] = selectedPreferencesCopy[index + 1];
      selectedPreferencesCopy[index + 1] = temp;
      setAllPreferences(selectedPreferencesCopy);
    }
  };

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Candidate Preferences</span>
            {data?.showEdit && (
              <button
                className="btn btn-sm btn-light"
                onClick={() => data?.setEditMode(true)}
              >
                Edit
              </button>
            )}
          </div>
        </div>
        <div className="card-body">
          <>
            <div
              style={{
                maxHeight: "370px",
                overflowY: "auto",
                position: "relative",
              }}
            >
              {data?.canEdit && (
                <div className="d-flex flex-wrap align-items-center">
                  <button
                    type="button"
                    className="btn btn-sm text-white btn-info mt-3 ms-md-5"
                    onClick={handleMoveToTop}
                  >
                    Move To Top <FontAwesomeIcon icon={faAngleUp} />
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm text-white btn-info mt-3 ms-2"
                    onClick={handleMoveToBottom}
                  >
                    Move To Bottom <FontAwesomeIcon icon={faAngleDown} />
                  </button>
                  <p className="ms-md-2 mt-4 my-2">Move To Priority No. :</p>
                  <div className="d-flex align-items-center">
                    <input
                      className="form-control mt-3 ms-2 me-md-2"
                      type="number"
                      min="0"
                      placeholder="priority number"
                      value={priorityInput}
                      onChange={(e) => setPriorityInput(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-sm text-white btn-info mt-3 ms-2"
                      onClick={handleMoveToIndex}
                    >
                      Go
                    </button>
                  </div>
                </div>
              )}
              <table className="table table-striped table-bordered table-hover mt-3">
                <thead>
                  <tr>
                    {/* <th scope="col" style={{ width: "10%" }}>
                      Index
                    </th> */}
                    <th scope="col" style={{ width: "30%" }}>
                      Post
                    </th>
                    <th scope="col" style={{ width: "30%" }}>
                      Place
                    </th>
                    <th scope="col" style={{ width: "20%" }}>
                      Priority
                    </th>
                    {data?.canEdit && (
                      <th scope="col" style={{ width: "40%" }}>
                        Required Actions
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {allPreferences?.map((preference, index) => (
                    <tr key={index}>
                      {/* <td>{preference.id}</td> */}
                      <td>{preference.departmentName}</td>
                      <td>{preference.qualificationCategory}</td>
                      <td>{index + 1}</td>
                      {data?.canEdit && (
                        <td scope="col" style={{ width: "11%" }}>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => handleRowShift(index, "up")}
                          >
                            &#129033;
                          </button>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => handleRowShift(index, "down")}
                          >
                            &#129035;
                          </button>
                          <input
                            type="radio"
                            name="selectOption"
                            className="ms-2"
                            checked={selectedId === index}
                            onChange={() => handleSelectId(index)}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
          <div
            className="mt-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {data?.activeIndex !== 0 && data?.showBack ? (
              <button
                type="button"
                className="btn btn-sm btn-info text-white"
                onClick={data?.goBack}
              >
                Back
              </button>
            ) : (
              <div></div>
            )}
            {data?.showCancel && (
              <>
                <div style={{ marginRight: "auto" }}>
                  {
                    <button
                      className="btn btn-sm btn-danger text-white"
                      type="button"
                      onClick={() => {
                        fetchSelectedPreferencesApiCall();
                        data?.setEditMode(false);
                      }}
                    >
                      Cancel
                    </button>
                  }
                </div>
              </>
            )}
            {data?.showSubmit && (
              <>
                <div style={{ marginLeft: "auto" }}>
                  {
                    <button
                      className="btn btn-sm btn-success text-white"
                      type="button"
                      onClick={() => handleSubmit()}
                    >
                      Submit
                    </button>
                  }
                </div>
              </>
            )}
            {data?.showNext && (
              <div>
                {
                  <button
                    className="btn btn-sm btn-success text-white"
                    type="button"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                }
              </div>
            )}
          </div>
        </div>
      </div>
      {milestoneInst && milestoneInst.length > 0 && (
        <div className="card mt-3">
          <div className="col-sm-12">
            {Array.isArray(milestoneInst) &&
              milestoneInst.map((inst, index) => (
                <div className="m-3" key={index}>
                  <div dangerouslySetInnerHTML={{ __html: inst.instruction }} />
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CandidatePreference;
